export default __webpack_public_path__ + "static/media/bg_smll_04.85bf055e.png";